<template>
  <v-card style="overflow: hidden">
    <v-row no-gutters align="stretch">
      <v-col cols="2" class="primary text-center py-2 d-flex flex-column justify-center">
        <div class="white--text" v-text="$t('trainingsession.fields.networkdiagram.title')" />
        <v-simple-checkbox
          v-model="internalValue.active"
          class="mt-1"
          dark
          @input="change"
        />
      </v-col>
      <v-col />
    </v-row>
  </v-card>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'

export default {
  name: 'NetworkdiagramSessionForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    internalValue: null,
  }),
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        this.internalValue = Helpers.clone(this.value)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
    },
  },
  rules: {
    durationInSeconds: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.greater', { number: 0 }),
    ],
  },
}
</script>
